module.exports = __webpack_public_path__ + "10_mole.e5bba817.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer2/10_mole.png
// module id = R/as
// module chunks = 0